define('plugin/invoice/view/InvoicePaymentMethodListItemView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * @class InvoicePaymentMethodListItemView
     */
    return LayoutView.extend({

        template: '#invoice_payment_method_list_item_view',

        ui: {
            'deleteBtn': '.sb-delete-pm'
        },
        triggers: {
            'click @ui.deleteBtn': 'payment_method:delete'
        }

    });

});
